// URLs
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL
export const LANDING_URL = process.env.REACT_APP_LANDING_URL
export const CABINET_URL = process.env.REACT_APP_CABINET_URL

// LOCAL STORAGE
export const LOCALSTORAGE_KEY = process.env.REACT_APP_LOCALSTORAGE_KEY
export const DECLINE_COOKIE_DATE_LOCALSTORAGE_KEY = `${LOCALSTORAGE_KEY}-declinecookie`
export const DISCOUNT_LOCALSTORAGE_KEY = `${LOCALSTORAGE_KEY}-landing-discount`
// TELEGRAM
export const TELEGRAM_BOT_ID = process.env.REACT_APP_TELEGRAM_BOT_ID
export const TELEGRAM_BOT_NAME = process.env.REACT_APP_TELEGRAM_BOT_NAME

export const LANGUAGES = {
  ru: 'Русский',
  en: 'English',
  id: 'Indonesia',
}

export const USER_STATUS_NEW = 0
export const USER_STATUS_ACTIVE = 1
export const USER_STATUS_BLOCKED = 10

export const BLOCKCHAIN_RELICTUM = 'RELICTUM'
export const BLOCKCHAIN_TRX = 'TRX'
export const BLOCKCHAIN_ETH = 'ETH'
export const BLOCKCHAIN_BSC = 'BSC'

// FIAT
export const CURRENCY_USD = 'USD'

// CRYPTO
export const CURRENCY_USCR = 'USCR'
export const CURRENCY_USDR = 'USDR'
export const CURRENCY_USDT = 'USDT'
export const CURRENCY_USDC = 'USDC'
export const CURRENCY_TRX = 'TRX'
export const CURRENCY_BUSD = 'BUSD'
export const CURRENCY_BNB = 'BNB'
export const CURRENCY_DAI = 'DAI'
export const CURRENCY_ETH = 'ETH'

// CRYPTO TOKENS
export const CURRENCY_DCGT = 'DCGT'

// BASE
export const CURRENCY_BASE = CURRENCY_USCR
export const CURRENCY_USCR_NAME = 'U$CR'

export const CURRENCY_DESCRIPTIONS = {
  [`${BLOCKCHAIN_TRX}_${CURRENCY_USDT}`]: 'Tether TRC20',
  [`${BLOCKCHAIN_ETH}_${CURRENCY_USDT}`]: 'Tether ERC20',
  [`${BLOCKCHAIN_BSC}_${CURRENCY_USDT}`]: 'Tether BEP20',
  [CURRENCY_DCGT]: 'DC Grove Token',
  [CURRENCY_TRX]: 'Tron',
  [CURRENCY_USCR]: 'USD Coinrealtor',
  [CURRENCY_USDR]: 'USD Relictum',
  [CURRENCY_USDC]: 'USD Coin',
  [CURRENCY_BUSD]: 'Binance USD',
  [CURRENCY_BNB]: 'Binance Native Coin',
  [CURRENCY_DAI]: 'Ethereum-based Coin',
  [CURRENCY_ETH]: 'Ethereum',
}

export const CURRENCY_ICONS = {
  [`${BLOCKCHAIN_TRX}_${CURRENCY_USDT}`]: '/uploads/trc20.svg',
  [`${BLOCKCHAIN_ETH}_${CURRENCY_USDT}`]: '/uploads/erc20.svg',
  [`${BLOCKCHAIN_BSC}_${CURRENCY_USDT}`]: '/uploads/coin-binance-usdt.svg',
  [CURRENCY_DCGT]: '/uploads/coin-dcgt-v2.svg',
  [CURRENCY_USCR]: '/uploads/uscr.svg',
  [CURRENCY_USDR]: '/uploads/usdr.svg',
  [CURRENCY_TRX]: '/uploads/tron.svg',
  [CURRENCY_USDC]: '/uploads/usdc.svg',
  [CURRENCY_BUSD]: '/uploads/coin-busd.svg',
  [CURRENCY_BNB]: '/uploads/coin-bnb.svg',
  [CURRENCY_DAI]: '/uploads/coin-dai.svg',
  [CURRENCY_ETH]: '/uploads/etherium.svg',
}

export const MIN_AMOUNTS = {
  [CURRENCY_BASE]: 10,
  [CURRENCY_USDT]: 10,
  [CURRENCY_TRX]: 10,
  [CURRENCY_BUSD]: 10,
  [CURRENCY_BNB]: 10,
  [CURRENCY_USDC]: 10,
  [CURRENCY_DAI]: 10,
  [CURRENCY_ETH]: 10,
}

export const BLOCKCHAIN_LABELS = {
  [BLOCKCHAIN_RELICTUM]: 'Relictum',
  [BLOCKCHAIN_ETH]: 'Ethereum',
  [BLOCKCHAIN_TRX]: 'Tron',
  [BLOCKCHAIN_BSC]: 'Binance Smart Chain',
}

export const BLOCKCHAIN_ICONS = {
  [BLOCKCHAIN_RELICTUM]: '/uploads/relictum.svg',
  [BLOCKCHAIN_ETH]: '/uploads/etherium.svg',
  [BLOCKCHAIN_TRX]: '/uploads/tron.svg',
  [BLOCKCHAIN_BSC]: '/uploads/binance.svg',
}

// WALLET TYPES
export const WALLET_TYPE_USCR = 10
export const WALLET_TYPE_USDR = 20
export const WALLET_TYPE_DCGT = 30
export const WALLET_TYPE_USDT = 40

// INVOICE STATUSES
export const INVOICE_STATUS_NEW = 0
export const INVOICE_STATUS_CANCELLED = 1
export const INVOICE_STATUS_PAID = 2

// INVOICE TYPES
export const INVOICE_TYPE_PURCHASE_TOKENS = 100

// TRANSACTION TYPES
export const TRANSACTION_TYPE_REPLENISHMENT = 4
export const TRANSACTION_TYPE_WITHDRAWAL = 5
export const TRANSACTION_TYPE_TRANSFER = 6
export const TRANSACTION_TYPE_PURCHASE_TOKENS = 500
export const TRANSACTION_TYPE_REFERRAL_BONUS = 510

// TRANSACTION STATUSES
export const TRANSACTION_STATUS_NEW = 0
export const TRANSACTION_STATUS_PROCESSED = 1
export const TRANSACTION_STATUS_CANCELLED = 2

// PAYMENT SYSTEM TYPES
export const PAYMENT_SYSTEMS_INTERNAL = 4
export const PAYMENT_SYSTEMS_NODE = 10
export const PAYMENT_SYSTEMS_CRYPTO_GATEWAY = 15

export const PURCHASE_MIN_AMOUNT = 500 // BASE_CURRENCY

// calculator amount types
export const TYPE_AMOUNT = 'amount'
export const TYPE_CURRENCY_AMOUNT = 'currencyAmount'

// DISCOUNT
export const DISCOUNT_END_DATE = '31.01.2023 21:59'
export const DISCOUNT_START_DATE = '27.12.2022 00:00'
